import { useRef, useEffect, useState } from "react";
import styled from 'styled-components';

import { savePDF } from "@progress/kendo-react-pdf";

import StaffSheetLayout from './StaffSheetLayout';
import DummyTemplate from './DummyTemplate';
import PageTemplate from './PageTemplate';

const DisplayContainer = styled.div`
  height: 100vh;
  overflow-y: scroll;
  display: flex;
  justify-content: center;
`

const Page = styled.div`
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  padding: 0.2in 0 0.5in 0;
  width: 6.3in;
  min-height: 8.2in;
`

const PageSpacer = styled.div`
  margin-top: 100px;
  margin-bottom: 100px;
`;

const PageBottom = styled.div`
  height: 100px;
`;


const ControlPanel = styled.div`
  display: flex;
  flex-direction: row-reverse;
  position: absolute;
  right: 0;
  bottom: 8px;
`

const StyledButton = styled.button`
  color: #fff;
  background-color: #18C371;
  border: none;
  margin: 0 8px;
  font-weight: bold;
  cursor: pointer;
`

const SquareButton = styled(StyledButton)`
  padding: 12px;
  border-radius: 6px;
`;

// const CircleButton = styled(StyledButton)`
//   height: 3em;
//   width: 3em;
//   text-align: center;
//   padding: 12px;
//   border-radius: 100px;
//
// `;

const PDFDisplay = ({formValues}) => {
  const exportRef = useRef(null);

  const pageRef = useRef(null);
  const [pageHeight, setPageHeight] = useState(0);

  useEffect(() => {
    setPageHeight(pageRef.current.clientHeight)
  },[pageHeight, formValues])

  const exportPDFWithMethod = () => {
    let element = exportRef.current;
    const d = new Date();

    let timeText = d.toLocaleString('en-US', { dateStyle: "short", timeStyle: "medium" });
    const Template = (props) => <PageTemplate time={timeText} title={formValues.projectName} {...props}/>

    savePDF(element, {
      paperSize: "Letter",
      fileName: 'test',
      margin: "0.5in",
      pageTemplate: Template
    });
  };

  return (
    <DisplayContainer>
      <PageSpacer>
        <Page ref={pageRef}>
          <DummyTemplate
            title={formValues ? formValues.projectName.length > 0 ? `"${formValues.projectName}"` : `"Untitled"` : `"Untitled"`}
            height={pageHeight}
          />
          <div ref={exportRef}>
            <StaffSheetLayout data={formValues}/>
          </div>
        </Page>
        <PageBottom/>
      </PageSpacer>
      <ControlPanel>
        <SquareButton onClick={() => exportPDFWithMethod()}>Download PDF</SquareButton>
      </ControlPanel>
    </DisplayContainer>
  )
}

export default PDFDisplay;
